import { Color, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface ReviewEntriesColumnHeaderProps {
  label: string
  tooltip: string
}

export const ReviewEntriesColumnHeader = ({ label, tooltip }: ReviewEntriesColumnHeaderProps): ReactElement => (
  <Styled.ReviewEntriesColumnHeaderWrapper>
    <Tooltip as="span" delay={0} label={tooltip} placement="top">
      <Text as="span" color={Color.Grey950} truncate weight="medium">
        {label}
      </Text>
    </Tooltip>
  </Styled.ReviewEntriesColumnHeaderWrapper>
)
